<template>
  <div class="home">
    <select-enterprise v-on:selectEnterprise="select" :error="error">
    </select-enterprise>
  </div>
</template>

<script>
import { AWSEventBus } from '@bag-era/cognito-authentication';
import axios from 'axios'

export default {
  name: 'SelectEnterpriseView',
  data() {
    return {
      error: null,
    };
  },
  mounted() {
    this.$store.dispatch('setEnterprise', null);
    this.$store.dispatch('setUser', null);
  },
  methods: {
    select(data) {
      const client = window.btoa(data);
      axios.get(`${this.$store.getters.url}client/${client}`).then((res) => {
        if (res.data.Items.length > 0) {
          let enterprise = res.data.Items[0];
          enterprise.id64 = client;
          this.$store.dispatch('setEnterprise', enterprise);
          AWSEventBus.$emit('selectEnterprise', res.data.Items[0]);
        } else {
          this.error = "L'entreprise choisi n'existe pas";
        }
      }).catch(() => {
        this.error = this.error = "L'entreprise choisie n'existe pas";
      });
    },
  },
};
</script>
